import { Pipe, PipeTransform } from '@angular/core';
import { INamedPerson } from 'ngx-mat-esign360/lib/shared/model/named-person.model';

@Pipe({
  name: 'personFullName',
})
export class PersonFullNamePipe implements PipeTransform {
  transform(person: INamedPerson): string {
    if (!person) {
      console.warn(`personFullName pipe called with person = ${person}`);
      return '';
    }
    const middleName = person.middleName ? `${person.middleName} ` : '';
    const degree = person.degree ? `${person.degree} ` : '';
    const additionalDegree = person.additionalDegree ? ` ${person.additionalDegree}` : '';

    return `${degree}${person.forename} ${middleName}${person.surname}${additionalDegree}`;
  }
}
